import { prefix } from "../../design-tokens/meta";
import { matchers } from "../../js/validate-props";
import { events } from "../../js/state-machine";

export const componentName = "Form";

export const defaultProps = Object.freeze({
    fallbackErrorMessage: "Error",
});

export const schema = Object.freeze({
    fallbackErrorMessage: matchers.string,
});

export const eventMap = Object.freeze({
    success: events.success(`${componentName}Submit`),
    failure: events.failure(`${componentName}Submit`),
});

export const componentClasses = Object.freeze({
    form: {
        base: `${prefix}form`,
        validated: `${prefix}form--was-validated`,
        invalid: `${prefix}form--invalid`,
    },
    section: `${prefix}form__section`,
});

export const views = Object.freeze({
    form: {
        basic: {
            classList: [componentClasses.form.base, `!${componentClasses.form.validated}`],
            attrs: { novalidate: "" },
        },
        validated: { classList: [componentClasses.form.validated] },
        valid: {
            classList: [`!${componentClasses.invalid}`],
        },
        invalid: {
            classList: [componentClasses.invalid],
        },
    },
    control: {
        valid: {
            attrs: { "aria-invalid": null, "aria-describedby": null },
        },
        invalid: {
            attrs: { "aria-invalid": "true" },
        },
    },
    field: {
        valid: {
            classList: [`${prefix}is--valid`],
        },
        invalid: {
            classList: [`${prefix}is--invalid`],
        },
        base: {
            classList: [`!${prefix}is--valid`, `!${prefix}is--invalid`],
        },
    },
});

export const fieldTypes = Object.freeze({
    inputText: {
        field: `${prefix}input-text__container`,
        control: `${prefix}input-text`,
    },
    select: {
        field: `${prefix}select`,
        control: `${prefix}select__field`,
    },
    radio: {
        field: `${prefix}radio-button`,
        control: `${prefix}radio-button__input`,
    },
    checkbox: {
        field: `${prefix}checkbox`,
        control: `${prefix}checkbox__input`,
    },
    checkboxGroup: {
        field: `${prefix}checkbox-group`,
        control: `${prefix}checkbox__input`,
    },
    textarea: {
        field: `${prefix}text-area__container`,
        control: `${prefix}text-area`,
    },
    datePicker: {
        field: `${prefix}date-picker`,
        control: `${prefix}date-picker__input`,
    },
});

export const errorClasses = [
    `${prefix}error-text`,
    `${prefix}invalid-feedback`,
    `${prefix}date-picker__invalid-feedback`,
];

export const helperClasses = [
    `${prefix}helper-text`,
    `${prefix}input-text__helper`,
    `${prefix}select__helper`,
    `${prefix}date-picker__helper`,
];
